import React from "react";
import { useHistory } from "react-router";

import { getFromQueryString } from "modules/EmailBrowser/utils";
import { useCookies } from "react-cookie";
import { getUserPlanType } from "modules/Login/action";

const SSO: React.FC = (props: any) => {
  const csrfToken = props.match.params.csrfToken;
  const firstLogin = getFromQueryString("firstlogin");
  const hasCampaigns = getFromQueryString("hasCampaigns");
  const [cookies, setCookies, removeCookies] = useCookies([]);

  const history = useHistory();
  getUserPlanType(history, firstLogin, hasCampaigns);

  localStorage.setItem("csrfToken", csrfToken);

  let now = new Date();
  let year = now.getFullYear();
  let month = now.getMonth();
  let day = now.getDate();
  let cookieExpiry = new Date(year + 1, month, day);
  let domain = ".xiqonline.com";
  if (window.location.hostname === "localhost") {
    domain = "localhost";
  }
  setCookies("isLogout", "0", {
    path: "/",
    expires: cookieExpiry,
    domain: domain,
  });
  return <></>;
};

export default SSO;
